export default __webpack_public_path__ + "static/media/Vector 1.411a5047.svg";